import { LOGO } from "@/i18n/assets";
import { useSite } from "@/context/SiteContentContext";
import { toAbsolute } from "@/lib/api";

// Icon-only brand emblem on a clean white disc so the navy artwork reads on dark backgrounds.
export const BrandMark = ({ size = 46, className = "" }) => {
  const { settings } = useSite();
  const logo = toAbsolute(settings.brand_logo_url) || LOGO;
  return (
    <span
      className={`inline-grid place-items-center rounded-full bg-white shrink-0 ${className}`}
      style={{ width: size, height: size, boxShadow: "0 6px 20px rgba(0,0,0,0.25)" }}
      aria-label="Madenati"
      role="img"
    >
      <img src={logo} alt="Madenati" style={{ width: size * 0.9, height: size * 0.9 }} className="object-contain" />
    </span>
  );
};

export const Wordmark = ({ lang, withTagline = true }) => {
  const { identity } = useSite();
  const name = (identity && identity[`name_${lang}`]) || (lang === "en" ? "Madenati" : lang === "ku" ? "مەدینەتی" : "مدينتي");
  const tagline = (identity && identity[`tagline_${lang}`]) || (lang === "en" ? "Smart Solutions" : lang === "ku" ? "چارەسەری زیرەک" : "حلول ذكية");
  return (
    <span className="hidden sm:flex flex-col leading-none">
      <span className="font-extrabold text-lg tracking-tight">{name}</span>
      {withTagline && <span className="text-[11px] text-primary font-medium mt-1">{tagline}</span>}
    </span>
  );
};
